function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dataops_service from '@/apps/dataops/services/dataops_service';
import { mapMutations } from 'vuex';
import tasks from '@/js/tasks';
export default {
  name: 'Orchestrator',
  components: {},
  mixins: [],
  data: function data() {
    return {
      isLoading: false,
      valid: false,
      orchestrator: {
        enviroment: [{
          text: 'Desarrollo',
          value: 'dev'
        }, {
          text: 'Producción',
          value: 'prod'
        }],
        enviroment_in: [],
        enviroment_out: []
      },
      form: {
        enviroment_in: 'dev',
        enviroment_out: 'prod'
      },
      jobs: [{
        id: 1,
        jobDetail: ''
      }],
      jobsoris: [],
      rules: {
        required: function required(value) {
          return !!value || 'Este campo es requerido.';
        },
        itemsNotEmpty: function itemsNotEmpty(value) {
          return value && value.length > 0 || 'No hay elementos disponibles.';
        }
      },
      detail: {
        JobName: '',
        Variables: []
      }
    };
  },
  created: function created() {
    this.loadEnviroments();
  },
  beforeMount: function beforeMount() {},
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    loadEnviroments: function loadEnviroments() {
      var _this = this;
      this.setShowLoading(true);
      dataops_service.getInEnviroments().then(function (response) {
        if (response.status_code === 200) {
          _this.orchestrator.enviroment_in = response.data;
        }
      });
      dataops_service.getOutEnviroments().then(function (response) {
        if (response.status_code === 200) {
          _this.orchestrator.enviroment_out = response.data;
          _this.setShowLoading(false);
        }
      });
    },
    listJobs: function listJobs() {
      var _this2 = this;
      this.setShowLoading(true);
      var version = this.form.enviroment_in;
      dataops_service.postJobsOrigs(version).then(function (response) {
        if (response.status_code === 200) {
          _this2.jobsoris = response.data;
        }
        _this2.setShowLoading(false);
      });
    },
    save: function save() {
      var _this3 = this;
      this.setShowLoading(true);
      if (this.$refs.form.validate()) {
        var data_to_send = {
          'versionori': this.form.enviroment_in,
          'versiondes': this.form.enviroment_out,
          'jobs': this.jobDetailsAsCommaSeparated
        };
        dataops_service.saveOrchestrator(data_to_send).then(function (response) {
          _this3.isLoading = false;
          if (response.status_code === 200) {
            _this3.setShowLoading(false);
            tasks.toast.success(_this3.translate('frases.successfully_registered'));
          }
        });
      }
    },
    addJob: function addJob() {
      var id = this.jobs.length + 1;
      this.jobs.push({
        id: id,
        jobDetail: ''
      });
    },
    removeJob: function removeJob(index) {
      this.jobs.splice(index, 1);
      // Re-asignar IDs
      this.jobs.forEach(function (job, idx) {
        job.id = idx + 1;
      });
    },
    viewJob: function viewJob(index) {
      var _this4 = this;
      this.setShowLoading(true);
      var job = this.jobs[index];
      dataops_service.postVarsori(this.form.enviroment_in, job.jobDetail).then(function (response) {
        if (response.status_code === 200) {
          _this4.detail = response.data;
        }
        _this4.setShowLoading(false);
      });
    }
  }),
  computed: {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    jobDetailsAsCommaSeparated: function jobDetailsAsCommaSeparated() {
      return this.jobs.map(function (job) {
        return job.jobDetail;
      }).join(',');
    }
  }
};